import { render, staticRenderFns } from "./Odyssey.vue?vue&type=template&id=6377362c&scoped=true&"
import script from "./Odyssey.vue?vue&type=script&lang=js&"
export * from "./Odyssey.vue?vue&type=script&lang=js&"
import style0 from "./Odyssey.vue?vue&type=style&index=0&id=6377362c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6377362c",
  null
  
)

export default component.exports